import { useMutation, useQuery } from "@tanstack/react-query";
import queryKey from "../../../../../enumerations/queryKey";
import { apiGetDepositCount, apiPutDepositRead } from "./service";

export const usePutDepositRead = () => {
  return useMutation((params) => apiPutDepositRead(params).then((res) => res.data.data));
};

export const useGetDepositCount = ({ options }) => {
  return useQuery(
    [queryKey.DEPOSIT_COUNT],
    () =>
      apiGetDepositCount().then((res) => {
        return res.data?.data;
      }),
    {
      ...options,
    },
  );
};
